export enum MembershipStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  PENDING = "pending",
}

export enum InvitationState {
  PENDING = "pending",
  ACCEPTED = "accepted",
  REVOKED = "revoked",
  CANCELLED = "cancelled",
  EXPIRED = "expired",
}
